/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { map, take, toArray } from 'rxjs/operators';
import { concat, Observable } from 'rxjs';

import { LanguageIdResolver, ChannelResolver, ListingResolver } from '@shared/resolvers';
import { CreditBalanceResolver } from './credit-balance.resolver';
import { LoadingService } from '@shared/services/loading/loading.service';

@Injectable()
export class ComposedCreditBalanceResolver {
  constructor(
    private readonly _languageIdResolver: LanguageIdResolver,
    private readonly _listingResolver: ListingResolver,
    private readonly _channelResolver: ChannelResolver,
    private _creditBalanceResolver: CreditBalanceResolver,
    private _loadingService: LoadingService
  ) {}

  /*
   * Resolve ComposedListingRequests
   * 1. Start Loading Service
   * 2. Resolves Listing
   * 3. Resolves Channel
   * 4. Resolves LanguageId
   * 5. Resolves CreditBalance
   */
  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    this._loadingService.start();

    return concat(
      this._listingResolver.resolve(route, state),
      this._channelResolver.resolve(route, state),
      this._languageIdResolver.resolve(route),
      this._creditBalanceResolver.resolve()
    ).pipe(
      take(4),
      toArray(),
      map(([listing, channel, , views]) => {
        this._loadingService.stop();
        return { listing, channel, views };
      })
    );
  }
}
